module.exports = __webpack_public_path__ + "static/img/brand-8.9837d7f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/brand-8.svg
// module id = /oG3
// module chunks = 0